<template>
    <div class="wrapper">
        <alert :type="alertType"
               :dismiss="3000"
               @dismissed="alert = false"
               v-if="alert"
               :show="alert">
            {{ this.alertMessage }}
        </alert>
        <h1>Fragen</h1>
        <section class="u-mt--medium">
            <div class="grid">
                <div class="col-6">
                    <input v-model="searchQuery" @keyup="filterId = 'search'" type="text" placeholder="Suchen">
                    <button class="input-icon" @click="filterId = 'search'" :class="{active: filterId == 'search'}"><i class="fas fa-search"></i></button>
                </div>
                <div class="col-6 u-right">
                    <button @click="popup = true" class="button button--large">Stellen Sie eine neue Frage<i class="far fa-plus-square"></i></button>
                </div>
            </div>
        </section>
        <popup v-if="popup" @close="popup = false" title="Frage einreichen">
            <form @submit.prevent="submit" class="u-mt--small" ref="form">
                <label>Frage *</label>
                <textarea name="Question" type="text" placeholder="Ihre Frage" class="full" required></textarea>
                <label>Ihr Name *</label>
                <input name="Name" type="text" placeholder="Ihr Name" class="full" required>
                <label>E-Mail Adresse *</label>
                <input name="Email" type="email" placeholder="E-Mail Adresse" class="full" required>

                <input name="publicQuestion" type="checkbox"><label>Diese Frage darf öffentlich gepostet werden</label>
                <input name="publicPersonalData" type="checkbox"><label>Mein Name darf veröffentlicht werden (ohne Email)</label>
                <input name="AGB" type="checkbox" required><label>Ich habe die <router-link to="datenschutz" target="_blank">rechtlichen Hinweise und Datenschutz-Richtlinien</router-link> gelesen und akzeptiere diese</label>
                <p>Ihre Frage wird erst nach interner Prüfung online veröffentlicht. Wir halten uns zudem das Recht vor, Aussagen die gewaltverherrlichend, rassistisch und sexistisch sind zu löschen und den zuständigen Behörden zu melden.</p>
                <p>* Pflichtfeld</p>
                <p class="u-right u-mt--small">
                    <button class="button">
                        Absenden
                        <i v-if="isSubmitting" class="fas fa-circle-notch fa-spin"></i>
                        <i v-else class="fas fa-arrow-right"></i>
                    </button>
                </p>
            </form>

        </popup>
        <section class="u-mt--medium">
            <div class="filter qfilter">
                <a @click="filterId = null; scrollToTop()"
                   :class="{active: filterId == null}"
                >Alle</a>
                <a v-for="tag in tags"
                   :key="tag.id"
                   @click="filterId = tag.id; scrollToTop()"
                   :class="{active: filterId == tag.id}"
                >{{ tag.title }}</a>
            </div>
        </section>
        <section class="u-mt--medium">
            <div class="grid">
                <div class="col-9">
                    <div v-for="question in filteredQuestions" :key="question.id">
                        <h2>{{ question.title }}</h2>
                        <div v-html="question.text"></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Fuse from 'fuse.js'
    import popup from '../components/Popup'
    import axios from "axios"
    import alert from '../components/Alert'

    export default {
        components: {
            popup,
            alert
        },
        data: function(){
            return {
                filterId: null,
                searchQuery: null,
                popup: false,
                isSubmitting: false,
                alert: false,
                alertType: "success",
                alertMessage: ""
            }
        },
        computed: {
            filteredQuestions(){
                let questions = this.questions
                let filterId = this.filterId
                let searchQuery = this.searchQuery

                if (!filterId){
                    return questions
                } else if (filterId == "search") {
                    let options = {
                        shouldSort: true,
                        keys: [
                            "title",
                            "text"
                        ]
                    }
                    let fuse = new Fuse(questions, options)
                    let results = fuse.search(searchQuery)
                    if (searchQuery.length) {
                        return results
                    } else {
                        return questions
                    }
                } else {
                    return questions.filter(function(question){
                        if (question.tags.some(tag => tag.id == filterId)){
                            return question
                        }
                    })
                }

            },
            questions(){
                return this.$store.state.questions.questions
            },
            tags(){
                return this.$store.state.questions.tags
            }
        },
        methods: {
            submit(){
                // Locking Mechanism
                if (!this.isSubmitting){
                    let vm = this
                    // Lock
                    this.isSubmitting = true
                    // Create empty data obj
                    let data = {}
                    data["fields"] = []

                    for(let field of this.$refs["form"].getElementsByTagName("textarea")){
                        data["fields"].push({name: field.name, value: field.value})
                    }
                    // Append form fields to data obj
                    for(let field of this.$refs["form"].getElementsByTagName("input")){
                        if(field.type == 'checkbox') {
                            data["fields"].push({name: field.name, value: field.checked ? 'Ja' : 'Nein'})
                        } else {
                            data["fields"].push({name: field.name, value: field.value})
                        }
                    }
                    // Append static values to data obj
                    data["action"] = "newQuestion"

                    // Send Data
                    axios({
                        method: "POST",
                        url: "https://pdf.education-cloud.eu",
                        data: JSON.stringify(data)
                    }).then((axiosResponse) => {
                      if(axiosResponse.status == 200 && axiosResponse.data.slice(-2) == "OK"){
                          this.alertType = "success"
                          this.alert = true
                          this.alertMessage = "Vielen Dank! Ihre Frage wurde erfolgreich versendet."
                      } else if(axiosResponse.status == 200) {
                          this.alertType = "error"
                          this.alertMessage = "Es gab ein Problem beim versenden der Frage, bitte versuchen sie es erneut."
                          this.alert = true
                      } else {
                          this.alertType = "error"
                          this.alertMessage = "Es gab ein Problem mit dem Server, bitte versuchen sie es erneut"
                          this.alert = true
                      }
                        // Unlock
                        vm.isSubmitting = false
                        this.popup = false
                    })
                }
            },
            scrollToTop() {
                window.scrollTo(0,0);
            },
            scrollCheck() {
              window.onscroll = function() {
                  if(window.scrollY > 480) {
                      document.getElementsByClassName("qfilter")[0].classList.add("fixed")
                  } else {
                      document.getElementsByClassName("qfilter")[0].classList.remove("fixed")
                  }
              }
            }
        },
        created: function() {
          this.scrollCheck()
        },
        mounted: function() {
          this.scrollCheck()
        },
        updated: function() {
          this.scrollCheck()
        }
    }

</script>

<style scoped lang="scss">

    .fixed {
        position: fixed;
        background-color: white;
        top: 0;
        width: 100%;
        padding: 20px;
    }


    textarea {
        width: 100%;
        font-size: 30px;
        padding: 10px 15px;
        border: none;
        margin-bottom: 20px;
        background-color: rgba(13, 55, 92, 0.1);
        font-family: freight-sans-pro, sans-serif;
        font-weight: 600;
        resize: vertical;
        color: #0d375c;
    }
    @media (max-width: 1620px) {
      .filter a {
          font-size: 24px;
      }
    }

    @media (max-width: 1380px) {
        .filter {
            display: flex;
            flex-wrap: wrap;
        }
        .filter a {
            width: 30%;
            margin: 0;
            text-align: center;
        }
    }
    @media (max-width: 1300px) {
        .qfilter .col-6 {
            grid-column: span 12;
            margin: 0 auto;
        }
        .button {
            padding: 12px;
            font-size: 24px;
        }
    }

    @media (max-width: 1000px) {
        .filter {
            top: 134px;
            left: 0;
            a {
                width: 100%;
                margin: 0;
                text-align: center;
            }
        }
    }
</style>
